export const detectSegmentationStructure = (data) => {
  if (!data) return 'none';

  // Check for new structure (has final_segments array)
  if (data.final_segments && Array.isArray(data.final_segments)) {
    return 'new';
  }

  // Check for old structure (has Segments array)
  if (data.Segments && Array.isArray(data.Segments)) {
    return 'old';
  }

  return 'unknown';
};
